import React from 'react';
import MessageContainer from 'js/modules/message/components/MessageContainer';
import AppHeaderContainer from 'js/modules/header/components/AppHeaderContainer';
import IssueListingContainer from 'js/modules/issue/components/IssueListingContainer';
import IssueConfigContainer from 'js/modules/issue/components/IssueConfigContainer';
import IssueCollectorCongratsContainer from 'js/modules/issue/components/IssueCollectorCongratsContainer';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import AppHelper from 'js/app/AppHelper';
import $ from 'jquery';
import { changeLanguage, getI18NMessage } from 'I18N/I18NHelper';
import { setHeaderHeight, closeCardTypeSettings, toggleMoreInstruction, closeOutlookSettings } from 'js/app/actions/AppActions';
import ModalComponent from 'js/modules/modal/components/ModalComponent';
import CardTypeConfigContainer from '../../modules/cardTypeConfig/components/CardTypeConfigContainer';
import IssuePreviewContainer from 'js/modules/preview/components/IssuePreviewContainer';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import OutlookConfigContainer from 'js/modules/outlookPluginConfig/components/OutlookConfigContainer';
import FeatureFlagProvider from 'js/toggle/FeatureFlagProvider';
import AppUtil from 'js/utils/AppUtil';
import versionInfo from 'VersionInfo';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
        this._handleKeyDown = this._handleKeyDown.bind(this);
        this._handleClickEvents = this._handleClickEvents.bind(this);
        this._handleWindowResize = this._handleWindowResize.bind(this);

        document.addEventListener("keydown", this._handleKeyDown);
        document.addEventListener("click", this._handleClickEvents);
        window.addEventListener("resize", this._handleWindowResize);

        if ( window.opener ) {
            window.onunload = function () {
                window.opener.location.reload();
            };
        }

        const userLang = navigator.language || navigator.userLanguage;
        changeLanguage(userLang);
    }

    componentDidMount() {
        AppUtil.loadCustomCSSFiles(['fonts/fonts-loader.css?RN=' + versionInfo.version]);

        this.props.initAppComp();
    }

    render() {
        const ctModalCfg = {
            modalCls: 'card-type-modal',
            headerText: getI18NMessage("card_type_pop_title"),
            onClose : () => { this.props.store.dispatch(closeCardTypeSettings()) }
        }

        let w_pluginWindowTitle = getI18NMessage("Generate_outlook_plugin");
        
        if (this.props.appData.pluginType === "outlook_web") {
            w_pluginWindowTitle = getI18NMessage("Generate_outlook_web_plugin")
        } else if (this.props.appData.pluginType === "outlook_windows") {
            w_pluginWindowTitle = getI18NMessage("Generate_outlook_windows_plugin");
        }

        const outlookModalCfg = {
            modalCls: 'outlook-modal',
            headerText: w_pluginWindowTitle,
            onClose : () => { this.props.store.dispatch(closeOutlookSettings()) }
        }

        const moreInstructionEnabled = this.props.appData.toggleMoreInstruction;

        const loadingImgSrc = AppHelper.getAppData('enterpriseType') === GLOBAL_CONSTANTS.SWIFTENTERPRISE ? 'images/loading.gif' : 'svg/loading.svg'

        return (
            <FeatureFlagProvider>
                {
                    this.props.openForm &&
                        <IssuePreviewContainer store={ this.props.store } openFrom="outside"/>
                }
                {
                    !this.props.openForm &&
                        this.props.appData.homePage === GLOBAL_CONSTANTS.ISSUE_LISTING && this.getICListing()
                }
                {
                    ( this.props.appData.homePage === GLOBAL_CONSTANTS.ADD_ISSUE_COLLECTOR || 
                        this.props.appData.homePage === GLOBAL_CONSTANTS.EDIT_ISSUE_COLLECTOR ) && <IssueConfigContainer store={ this.props.store } />
                }
                {
                    this.props.appData.homePage === GLOBAL_CONSTANTS.ISSUE_COLLECTOR_CONGRATS && <IssueCollectorCongratsContainer store={ this.props.store } />
                }
                <MessageContainer store={ this.props.store } />
                {
                    this.props.appData && this.props.appData.showMask &&
                    <div className='app_mask full_width full_height'>
                        <img src={ AppUtil.processURLForAppContextPath(loadingImgSrc) } 
                            className='vertical_align' alt='Loading'></img>
                    </div>
                }
                { 
                    this.props.appData.isCardTypeConfigOpen && 
                        <ModalComponent modalCfg={ctModalCfg} store={this.props.store}>
                            <CardTypeConfigContainer store={ this.props.store } />
                        </ModalComponent>
                }
                { 
                    this.props.appData.isOutlookConfigOpen && 
                        <ModalComponent modalCfg={outlookModalCfg} store={this.props.store}>
                            <OutlookConfigContainer store={ this.props.store } />
                        </ModalComponent>
                }
                {
                    moreInstructionEnabled &&
                        <div className='more_instruction_cnt'>
                            <span className='inst_heading bold float_left'>{ getI18NMessage('moreinstruction') }</span>
                            <span className='icon-close pos_abs inst_close_btn cur_pointer' onClick={ this.closeMoreInstructions.bind(this) }></span>
                            <div className="help_panel">
                                <div className='instruction_panel float_left'>
                                    {
                                        this.getHtmlPanelHelp()
                                    }
                                </div>
                                <div className='inst_help_seprator float_left'></div>
                                <div className='instruction_panel float_left'>
                                    {
                                        this.getJsPanelHelp()
                                    }
                                </div>
                                <div className='inst_help_seprator float_left'></div>
                                <div className='instruction_panel float_left'>
                                    {
                                        this.getMailPanelHelp()
                                    }
                                </div>
                            </div>
                            <div className="default_value_help">
                                {
                                    this.getDafultValueHelp()
                                }
                            </div>
                        </div>
                }
            </FeatureFlagProvider>
        )
    }

    closeMoreInstructions() {
        this.props.store.dispatch( toggleMoreInstruction() );
    }

    getJsPanelHelp() {
        const HtmlOpenText = '<html>';
        const HtmlCloseText = '</html>';
        const headtOpenText = '<head>'
        const headtCloseText = '</head>';
        const h1OpenText = '<h1>'
        const h1CloseText = '</h1>'
        const bodyOpenText = '<body>'
        const bodyCloseText = '</body>'
        const jqueryScriptOpenText = '<script src='
        const jqueryScriptCloseText = '></script>'
        const jqueryScriptOpenText1 = '<script>'
        const jqueryScriptCloseText1 = '</script>'

        return (
            <React.Fragment>
                <CustomScrollbar>
                    <span className='bold'>{ getI18NMessage('embedJS') }</span><br></br><br></br>
                    Copy the code and paste it into an existing JavaScript resource that is served on
                    any page where you want an External Work Request to appear. Note that this option requires
                    jQuery. So, ensure that jQuery is included before the External Work Request snippet.<br></br><br></br>
                    In the simplest form, the snippet can be inserted directly into the HTML code as shown below.<br></br><br></br>
                    <div className='html_inst_help'>
                        { HtmlOpenText }<br></br>
                        &emsp;{ headtOpenText }<br></br>
                        &emsp;&emsp;{ jqueryScriptOpenText }<span className='script_src'>"http://code.jquery.com/jquery-latest.js"</span>{ jqueryScriptCloseText }<br></br>
                        &emsp;&emsp;{ jqueryScriptOpenText1 }<br></br>
                        &emsp;&emsp;&emsp;<span className='help_html_desc'>Insert External Work Request code here</span><br></br>
                        &emsp;&emsp;{ jqueryScriptCloseText1 }<br></br>
                        &emsp;{ headtCloseText }<br></br>
                        &emsp;{ bodyOpenText }<br></br>
                        &emsp;&emsp;{ h1OpenText }<span className='help_color_black'>Hello World!</span>{ h1CloseText }<br></br>
                        &emsp;{ bodyCloseText }<br></br>
                        { HtmlCloseText }
                    </div>
                </CustomScrollbar>
            </React.Fragment>
        );
    }

    getHtmlPanelHelp() {
        const HtmlOpenText = '<html>';
        const HtmlCloseText = '</html>';
        const headtText = '<head>...</head>'
        const h1OpenText = '<h1>'
        const h1CloseText = '</h1>'
        const bodyOpenText = '<body>'
        const bodyCloseText = '</body>'

        return (
            <React.Fragment>
                <CustomScrollbar>
                    <span className='bold'>{ getI18NMessage('embedHtml') }</span><br></br><br></br>
                    Following are the ways to embed an External Work Request in HTML code<br></br><br></br>
                    <span className='bold'>Generic HTML application with the ability to modify application code</span><br></br>
                    Copy the code and paste it just above the { bodyCloseText } tag of your HTML code as shown in the example below.<br></br><br></br>
                    <div className='html_inst_help'>
                        { HtmlOpenText }<br></br>
                        &emsp;{ headtText }<br></br>
                        &emsp;{ bodyOpenText }<br></br>
                        &emsp;&emsp;{ h1OpenText }<span className='help_color_black'>Hello World!</span>{ h1CloseText }<br></br>
                        &emsp;&emsp;<span className='help_html_desc'>Insert External Work Request code here</span><br></br>
                        &emsp;{ bodyCloseText }<br></br>
                        { HtmlCloseText }<br></br><br></br>
                    </div>
                    <span className='bold'>Generic HTML application with Google Analytics</span><br></br>
                    To embed <span className='help_html_desc1'>Google Analytics</span> to your application, lots of web applications allow
                    you to add snippets into every page of your application. You can follow the same mechanism to embed
                    an External Work Request to your application by inserting the code above the Google Analytics code.
                </CustomScrollbar>
            </React.Fragment>
        );
    }

    getMailPanelHelp() {
        return (
            <React.Fragment>
                <CustomScrollbar>
                <span className='bold'>{ getI18NMessage('embedMail') }</span><br></br><br></br>
                <p> Copy the code and paste it into the body of an email message in any of your Outlook, Gmail, or Windows Mail domain 
                    and press <span className='bold'>Enter</span>. Mail domains like Outlook or Gmail automatically create a clickable hyperlink. However, you can even 
                    insert the code in a text or picture, which is present in your mail body. 
                     </p>
                     <br></br>
                     <p>
                     Perform the following steps to embed the code in a text or picture of your email body.
                     </p>
                     <br></br>
                <span>Using Outlook or Windows Email domain</span>
                <div>
                    <div><div className="sr_number">1.</div><div className="mail_instr_text"> &nbsp;Select the text or picture that you want to display as a hyperlink.</div></div>
                    <div><div className="sr_number">2.</div><div className="mail_instr_text"> &nbsp;On the <span className='bold'>Insert</span> tab, click <span className='bold'>Hyperlink</span>.
                    <div>You can also right-click the text or picture and click <span className='bold'>Hyperlink</span> on the shortcut menu.</div>
                    </div></div>
                    <div><div className="sr_number">3.</div><div className="mail_instr_text"> &nbsp;Copy the code and paste it in the <span className='bold'>Address</span> box.</div></div>
                </div>
                <br></br>
                <span>Using the Gmail domain</span>
                <div>
                    <div><div className="sr_number">1.</div><div className="mail_instr_text"> &nbsp;Select the text that you want to display as a hyperlink.</div></div>
                    <div><div className="sr_number">2.</div><div className="mail_instr_text"> &nbsp;Go to the taskbar located at the bottom of the composition window and click the <span className='bold'>hyperlink icon</span>.
                    <div>You can also click Ctrl + K.</div>
                    </div></div>
                    <div><div className="sr_number">3.</div><div className="mail_instr_text"> &nbsp;Copy the code and paste it in the URL link box and then click <span className='bold'>OK</span>.</div></div>
                </div>
                </CustomScrollbar>
            </React.Fragment>
        );
    }

    getDafultValueHelp() {
        return (
            <React.Fragment>
                <CustomScrollbar>
                <span className='bold'>Set Default Values for Fields in External Work Request Form</span><br></br>
                <p>Use the following instructions to set default values for any text fields like Name, Email address, when External Work Request form loads for the user: </p><br></br>
                <p>
                    <span className='bold'>For any custom text field:</span>You need to add a key for the <span className='bold'>custom text field </span> key. The key should have the same name as the field. 
                    If the field name has any spaces then replace them with an underscore. 
                    In this example, a custom field, called Application Version is added as a custom text field with an underscore in between the words and set to a default value, "version 1.0 "
                     &lt;script type="text/javascript" src="https:externalWorkRequestUrl.com?collectorid=5e663<span className='bold'>&Application_Version=version 1.0</span>"/&gt;
                    </p>
                    <br></br>
                    <p>
                    For <span className='bold'>“Name”</span> field: You need to add <span className='bold'>Name</span> key and set it to a default value. 
                    For example, &lt;script type="text/javascript" src="https:externalWorkRequestUrl.com?collectorid=5e663<span className='bold'>&Name=Mark Robinson</span>"/&gt;
                    </p>
                    <br></br>
                    <p>
                    For <span className='bold'>“Email Address”</span> field: You need to add <span className='bold'>Email_Address</span> key and set it to a default value. 
                    For example, &lt;script type="text/javascript" src="https:externalWorkRequestUrl.com?collectorid=5e663<span className='bold'>&Email_Address=markrobinson@abc.com</span>"/&gt;
                    </p><br></br>
                    <p>
                    <span className='bold'>Note: </span>The above URL parameters are not be provided by default. You need to set them in your URL you are using for  External Work Request inside your website.  
                    </p>
                </CustomScrollbar>
            </React.Fragment>
        )
    }

     /* istanbul ignore next */
    getICListing() {
        return (
            <React.Fragment>
                <AppHeaderContainer store={ this.props.store } />
                <IssueListingContainer store={ this.props.store } />
            </React.Fragment>
        );
    }

     /* istanbul ignore next */
    _handleKeyDown(event) {
        const state = this.props.store.getState();

        switch (event.keyCode) {
            case GLOBAL_CONSTANTS.ESCAPE_KEY:
                $('.cp_close').click();

                break;
            case GLOBAL_CONSTANTS.ENTER_KEY:
                const msg_btn = document.getElementById('msg_confimation');

                if (document.getElementsByClassName('message_confirmation').length > 0 && msg_btn
                    && state.messageData.messageData && state.messageData.messageData.show) {
                    msg_btn.click();
                }

                break;
            case GLOBAL_CONSTANTS.F1_KEY:
                if ( AppHelper.getAppData("helpURL") ) {
                    window.open(AppHelper.getAppData("helpURL"), "Help", "width=" + window.screen.availWidth +
                        "px,height=" + window.screen.availHeight + "px,top=0,left=0")
                }
                break;
            default:
                break;
        }
    }

     /* istanbul ignore next */
    _handleClickEvents(event) {
        const target = $(event.target);

        if ( target.parents('.MuiPopover-paper').length === 0 && !target.hasClass('MuiPopover-paper') ) {
            $('.cp_close').click();
        }
    }

     /* istanbul ignore next */
    _handleWindowResize() {
        const headerEl = document.getElementById('header');

        if ( headerEl ) {
            this.props.store.dispatch( setHeaderHeight(headerEl.offsetHeight) );
        }
    }

     /* istanbul ignore next */
    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
        document.removeEventListener("click", this._handleClickEvents);
        window.removeEventListener("resize", this._handleWindowResize);
    }
}

export default App;